export const GIF_PATH =
    'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1688039087/listings_assets/carousels_icons/3-Timer-98-Alpha.gif';
export const SOURCE_COMPONENT = 'recommendation_express_delivery';
export const BASE_KEY = 'search_perseus.recommendations.express_delivery';
export const URL = '/listings/fetch_express_recommendations';
export const BANNER_ROW = 3;
export const FIRST_HIGH_PRICED_GIGS = 3;
export const AMOUNT_OF_SHOWN_GIGS = 4;
export const BANNER_CLASS_NAME = 'express-delivery-banner';
